export const SET_OPTED_IN = "SET_OPTED_IN";
export const SET_ITEM_COUNT = "SET_ITEM_COUNT";
export const SET_IS_AVAILABLE = "SET_IS_AVAILABLE";
export const SET_TIER_NAME = "SET_TIER_NAME";
export const SET_TIER_NUMBER = "SET_TIER_NUMBER";
export const SET_ENABLE_COMPLIANCE_VARIANT = "SET_ENABLE_COMPLIANCE_VARIANT";
